import { Transaction } from '@mysten/sui/transactions';
import { runAsyncSafe } from '@web3/base-utils';
import { useWallet } from '@/hooks/wallet';

export const useSuiSignTransaction = () => {
  const { suiThirdPartyProvider, suiAccount } = useWallet();

  const suiSignAndTransaction = async (
    data: string
  ): Promise<[null, { digest: string }] | [Error, null]> => {
    // 从基座中获取sui链的provider
    const provider = suiThirdPartyProvider;
    //TODO: 实际数据还得调
    const tx = Transaction.from(data);
    const version = tx?.getData()?.version;

    const input = {
      transaction: tx,
      account: suiAccount,
      chain: 'sui:mainnet',
    };

    let features = 'signAndExecuteTransactionBlock';
    if (version === 2) {
      features = 'signAndExecuteTransaction';
    }

    // 钱包签名
    return await runAsyncSafe<{ digest: string }, Error>(
      provider?.features?.[`sui:${features}`]?.[features]?.(input)
    );
  };

  return {
    suiSignAndTransaction,
  };
};
